(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyDropdownMenuList', gmyDropdownMenuList);

  function gmyDropdownMenuList(
    $timeout,
    $window,
    $document
  ) {
    'ngInject';

    return {
      replace: true,
      restrict: 'E',
      scope: {
        list: '=',
        activeId: '=',
        onSelect: '&',
        navigation: '=?'
      },
      templateUrl: 'modules/common/directives/dropdown-menu-list/dropdown-menu-list.html',
      link(scope, element) {
        const container = element.closest('.dropdown-menu__inner-wrapper');

        scope.navigation = {
          index: -1,

          fixScroll() {
            const item = $window.$($document[0].getElementById(`${scope.$id}-${this.index}`));
            const top = item.position().top;

            if (top < 0) {
              container.scrollToElementAnimated(item, 0, 100);
            }

            if (top > 210) {
              container.scrollToElementAnimated(item, 210, 100);
            }
          },

          next() {
            $timeout(() => {
              this.index += 1;
              if (this.index >= scope.list.length) {
                this.index = 0;
              }
              this.fixScroll();
            });
          },

          prev() {
            $timeout(() => {
              this.index -= 1;
              if (this.index < 0) {
                this.index = scope.list.length - 1;
              }
              this.fixScroll();
            });
          },

          select() {
            if (scope.list[this.index]) {
              $timeout(() => scope.onSelect({ item: scope.list[this.index] }));
            }
          }
        };

        scope.$watch('list', (list) => {
          if (scope.navigation && list) {
            scope.navigation.index = list.length === 1 ? 0 : -1;
          }
        });
      }
    };
  }
})();
